import { mediaItems } from '@/mocks/home';

const mediaImages: Record<string, string> = {
  'media-01': 'https://readdy.ai/api/search-image?query=Animated%20comic%20style%20scene%20featuring%20epic%20battle%20between%20warriors%20with%20glowing%20energy%20effects%20dynamic%20action%20composition%20vibrant%20orange%20and%20warm%20red%20color%20palette%20japanese%20anime%20animation%20screenshot%20style%20with%20dramatic%20lighting%20and%20motion%20blur%20cinematic%20framing&width=640&height=360&seq=media-01&orientation=landscape',
  'media-02': 'https://readdy.ai/api/search-image?query=Artist%20workspace%20desk%20with%20manga%20drawing%20process%20showing%20sketch%20pencils%20and%20digital%20tablet%20comic%20panels%20being%20created%20warm%20amber%20lighting%20creative%20studio%20atmosphere%20professional%20manga%20artist%20scene%20editorial%20photography%20style&width=640&height=360&seq=media-02&orientation=landscape',
  'media-03': 'https://readdy.ai/api/search-image?query=Compilation%20montage%20of%20iconic%20shonen%20manga%20battle%20scenes%20with%20powerful%20warrior%20characters%20fighting%20dramatic%20moments%20warm%20orange%20red%20color%20grading%20action%20packed%20anime%20compilation%20style%20with%20speed%20lines%20and%20impact%20effects&width=640&height=360&seq=media-03&orientation=landscape',
  'media-04': 'https://readdy.ai/api/search-image?query=Manga%20artist%20interview%20scene%20in%20cozy%20studio%20setting%20with%20comic%20books%20on%20shelves%20warm%20ambient%20lighting%20casual%20conversation%20atmosphere%20behind%20the%20scenes%20creative%20process%20documentary%20style%20photograph%20with%20natural%20expressions&width=640&height=360&seq=media-04&orientation=landscape',
};

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">漫画视频</h2>
          <p className="text-sm md:text-base text-foreground-500">漫画改编动画、作画过程、精彩盘点视频合集</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {mediaItems.map((item) => (
            <a
              key={item.seq}
              href="#hero"
              className="flex flex-col bg-background-50 rounded-xl overflow-hidden group cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={mediaImages[item.seq]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-accent-500 group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 text-xs text-background-50 bg-black/60 px-2 py-0.5 rounded">
                  {item.duration}
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-1">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}